import Vue from 'vue'
import Vuex from 'vuex'
import common from '../assets/js/common'

Vue.use(Vuex)
let option = {
    /**
     * 初始化store
     */
    init() {
        this.state.token = window.localStorage.getItem('token') || ''
    },
    /**
     * 初始化用户
     */
    initUser() {
        store.dispatch('getCity')
        if (this.state.token) {
            store.dispatch('getUser')
        }
    },
    // 状态
    state: {
        user: '',
        token: '',
        // 默认舟山
        city: {
            deptName: '舟山',
            citycode: '0580'
        },
        cityArr: ''
    },
    // set方法
    mutations: {
        setUser(state, user) {
            state.user = user
        },
        setToken(state, token) {
            window.localStorage.setItem('token', token)
            state.token = token
        },
        logout(state) {
            window.localStorage.removeItem('token')
            state.user = ''
            state.tolen = ''
        },
        setCity(state, city) {
            state.city = city
        },
        setCityArr(state, arr) {
            state.cityArr = arr
        }
    },
    // get方法
    getters: {
        getUser: state => state.user,
        getToken: state => state.token,
        getCity: state => state.city,
        getCityArr: state => state.cityArr
    },
    actions: {
        // 一部获得用户
        getUser() {
            return new Promise((resolve, reject) => {
                common.querystringifyPost('/hdweb/portal/getUserByToken').then(res => {
                    if (res.data.code !== 403) {
                        store.commit('setUser', res.data.data)
                    }
                    resolve()
                })
            })
        },
        /**
         * 获取城市
         */
        async getCity() {
            let res = await common.querystringifyPost('/hdweb/portal/getAllCity')
            store.commit('setCity', res.data.data[0])
            store.commit('setCityArr', res.data.data)
        }
    }
}
option.init()
const store = new Vuex.Store(option)
option.initUser()
export default store



// WEBPACK FOOTER //
// ./src/store/index.js